import { render, staticRenderFns } from "./SelectedList.vue?vue&type=template&id=18335ce7&scoped=true&"
import script from "./SelectedList.vue?vue&type=script&lang=ts&"
export * from "./SelectedList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18335ce7",
  null
  
)

export default component.exports